import { render, staticRenderFns } from "./service_rank.vue?vue&type=template&id=2992f411&scoped=true&"
import script from "./service_rank.vue?vue&type=script&lang=js&"
export * from "./service_rank.vue?vue&type=script&lang=js&"
import style0 from "./service_rank.vue?vue&type=style&index=0&id=2992f411&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2992f411",
  null
  
)

export default component.exports